export enum InterceptorSkipHeader {
  antiforgery = 'X-SKIP-ANTIFORGERY',
  error = 'X-SKIP-ERROR',
  xsrf = 'X-SKIP-XSRF'
}
